/* unplugin-vue-components disabled */import script from "./before.vue?vue&type=script&setup=true&lang=js"
export * from "./before.vue?vue&type=script&setup=true&lang=js"

import "./before.vue?vue&type=style&index=0&id=7949bdbd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7949bdbd"]])

export default __exports__